<template>
    <div class="msg-subscr-msanage">
        <div class="hint block mb10">
            <div class="title">温馨提示</div>
            <p>逐条检查：一条一条的检查，因数据较多花费时间较长</p>
        </div>
        <div class="hint block mb10">
            <p>逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长</p>
        </div>
        <div class="hint block">
            <p>导入excel文件的单元格格式推荐使用常规或文本</p>
        </div>
        <div class="message-body mt10">
            <ul class="native-table">
                <li class="table-tr">
                    <div class="table-th" style="text-align: left">列名</div>
                    <div class="table-th" style="width: 120px">是否必填</div>
                    <div class="table-th" style="text-align: left">其他要求</div>
                    <!--<div class="table-th" style="text-align: left">正确示例</div>-->
                    <div class="table-th">不符合要求的结果</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">名称</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">编码</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-devc-brand-format-expl',
        desc: '自有资产品牌导入文件格式说明',
        data: function () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/DevcBrandFormatExpl.vue